import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _chunk from "lodash/chunk";
var _class, _descriptor, _descriptor2;
import { action, computed, observable } from 'mobx';
import { Collection } from 'core/model/Collection';
import GenericModel from 'core/model/Model';

// TODO fetchUrl vs url and httpMethod vs fetchMethod is an unnecessary footgun
// eslint-disable-next-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export let PagedCollection = (_class = class PagedCollection extends Collection {
  constructor(data = [], options = {}) {
    super(data, options);
    _initializerDefineProperty(this, "pageState", _descriptor, this);
    // should searchState and associated move up to Collection? Leaving here for now until searchState get solidified
    _initializerDefineProperty(this, "searchState", _descriptor2, this);
    this.addDiscreteFilter = discreteFilter => {
      this.removeDiscreteFilter(discreteFilter.type);
      this.setDiscreteFilters([...this.discreteFilters, discreteFilter]);
    };
    this.processData = this.processData.bind(this);
    this.reset = this.reset.bind(this);
    this.calculatePageCount();
  }
  get pagedFetchMethod() {
    return 'post';
  }
  setPageState(state = {}) {
    this.pageState = Object.assign(this.pageState, state);
  }
  setSearchState(state = {}) {
    this.searchState = Object.assign(this.searchState, state);
  }
  get pageModels() {
    const {
      page,
      perPage
    } = this.pageState;
    const chunks = _chunk(this.models, perPage);
    return page !== undefined ? chunks[page] : undefined;
  }

  /**
   * Just a shortcut helper for setting pageState offset and currentPage values when pagination page is selected.
   * @param page
   */
  setPage(page) {
    this.setPageState({
      offset: Math.ceil((page - 1) * this.pageState.perPage),
      currentPage: page
    });
  }
  applyPageChangeFilter() {
    const {
      currentPage,
      perPage
    } = this.pageState;
    const paginationDiscreteFilter = {
      type: 'pagination',
      fn: (_model, index) => index >= (currentPage - 1) * perPage && index < currentPage * perPage
    };
    this.addDiscreteFilter(paginationDiscreteFilter);
    this.filter();
  }
  calculatePageCount() {
    // remove pagination filter to ensure correct unfiltered size (not just 10 results per page)
    this.removeDiscreteFilter('pagination');
    this.filter();
    const {
      perPage,
      currentPage
    } = this.pageState;
    const pageCount = Math.ceil(this.size / perPage) || 1;
    this.setPageState({
      totalCount: this.size,
      pageCount,
      currentPage: currentPage > pageCount ? 1 : currentPage
    });
  }

  /**
   * Resets all pageState EXCEPT for perPage back to initial values
   */
  resetPageState() {
    this.setPageState({
      offset: 0,
      pageCount: 1,
      currentPage: 1,
      totalCount: 0,
      pageCountLoaded: false
    });
  }
  processData(response) {
    if (!response) {
      return super.processData(response);
    }
    const {
      metadata,
      pagination
    } = response;
    const totalCount = metadata && metadata.totalCount || pagination && Number(pagination.total_count) || 0;
    let pageCount = 1;
    if (totalCount && !Number.isNaN(totalCount) && totalCount > 0) {
      pageCount = Math.ceil(totalCount / this.pageState.perPage);
    }

    // if we have a 0 total count and more results, this state will be managed elsewhere (don't update here)
    if (!(totalCount === 0 && pagination?.has_more_results)) {
      this.setPageState({
        totalCount,
        pageCount
      });
    }
    return super.processData(response);
  }
  selectAll(options = {}) {
    const {
      pageCount
    } = this.pageState;
    const {
      selectedLimit = Number.MAX_VALUE
    } = options;
    if (pageCount === 1) {
      super.selectAll();
      return;
    }
    this.models.forEach(model => {
      if (this.selectedSize >= selectedLimit) {
        return;
      }
      model.select(options);
    });
  }
  reset(options = {}) {
    this.setPageState({
      offset: 0,
      pageCount: 1,
      currentPage: 1,
      perPage: 10,
      totalCount: 0
    });
    this.searchState = {};
    return super.reset(options);
  }

  /**
   * Just a helper so don't have to specify search options on queuedFetch all the time.
   */
  async pagedFetch(options = {}) {
    const {
      data,
      url,
      httpMethod,
      preserveSelection,
      query
    } = options;
    const pfHttpMethod = httpMethod || this.pagedFetchMethod;
    const pfUrl = url || (this.urlPaths && this.urlPaths.pagedFetch ? this.urlPaths.pagedFetch : this.url);
    return this.queuedFetch({
      data,
      fetchUrl: pfUrl,
      fetchMethod: pfHttpMethod,
      preserveSelection,
      query
    });
  }
  applyPagination() {
    this.calculatePageCount();
    this.applyPageChangeFilter();
  }
  resetDiscreteFilters() {
    super.resetDiscreteFilters();
    this.applyPagination();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "pageState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      offset: 0,
      pageCount: 1,
      currentPage: 1,
      perPage: 10,
      totalCount: 0,
      pageCountLoaded: false,
      groupedDataFracturedKey: undefined
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "searchState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "setPageState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPageState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSearchState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSearchState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pageModels", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pageModels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "applyPageChangeFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "applyPageChangeFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calculatePageCount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "calculatePageCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetPageState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetPageState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "processData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "processData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pagedFetch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "pagedFetch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetDiscreteFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetDiscreteFilters"), _class.prototype), _class);

/**
 * @deprecated prefer a typed PagedCollection
 */
export default class GenericPagedCollection extends PagedCollection {
  // Provide a default implementation for the model getter
  get model() {
    return GenericModel;
  }
}